import Icon from '../components/Icon.vue'

Icon.register({
  clipboard: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 112V464C384 490.5 362.5 512 336 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H128C128 28.7 156.7 0 192 0S256 28.7 256 64H336C362.5 64 384 85.5 384 112zM192 40C178.7 40 168 50.7 168 64S178.7 88 192 88 216 77.3 216 64 205.3 40 192 40M288 154V134A6-6 0 0 1 282 128H102A6-6 0 0 1 96 134V154A6-6 0 0 1 102 160H282A6-6 0 0 1 288 154z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clipboard.js
// module id = 7p6u
// module chunks = 144